import { render, staticRenderFns } from "./CustomerCartList.vue?vue&type=template&id=bdaba882&scoped=true&"
import script from "./CustomerCartList.vue?vue&type=script&lang=js&"
export * from "./CustomerCartList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCartList.vue?vue&type=style&index=0&id=bdaba882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaba882",
  null
  
)

export default component.exports